import { render, staticRenderFns } from "./controlloDDT.vue?vue&type=template&id=3fe84e46&"
import script from "./controlloDDT.vue?vue&type=script&lang=js&"
export * from "./controlloDDT.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports